export const initialValue = [{brandId: null, brandCode: ''}];
